import {Drawer as MUIDrawer, styled} from '@mui/material';
import React from 'react';

import dimensions from '@explorer/styles/dimensions.js';

export const Drawer = styled(MUIDrawer)(() => ({
  width: dimensions.leftSidebar.width,
  '& .MuiDrawer-paper': {
    position: 'absolute',
    overflow: 'visible',
  },
  '& .MuiDrawer-paperAnchorLeft': {
    width: dimensions.leftSidebar.width,
  },
  '& .MuiDrawer-paperAnchorRight': {
    width: dimensions.rightSidebar.width,
  },
}));

export const LeftDrawer = props => (
  <Drawer anchor="left" variant="persistent" {...props} />
);

export const RightDrawer = props => (
  <Drawer
    anchor="right"
    variant="persistent"
    className="pl-mode-dark"
    {...props}
  />
);
